import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import AddBabyModal from './AddBabyModal';
import AddActivityModal from './AddActivityModal';

export default function QuickActions() {
  const [showAddBabyModal, setShowAddBabyModal] = useState(false);
  const [showAddActivityModal, setShowAddActivityModal] = useState(false);
  const navigate = useNavigate();

  const actions = [
    {
      id: 'add-activity',
      title: 'Agregar Actividad',
      icon: 'ri-add-circle-line',
      color: 'from-teal-500 to-cyan-600',
      onClick: () => setShowAddActivityModal(true)
    },
    {
      id: 'add-baby',
      title: 'Agregar bebé',
      icon: 'ri-user-add-line',
      color: 'from-green-500 to-emerald-600',
      onClick: () => setShowAddBabyModal(true)
    },
    {
      id: 'feeding',
      title: 'Alimentación',
      icon: 'ri-heart-pulse-line',
      color: 'from-pink-500 to-rose-600',
      onClick: () => navigate('/feeding')
    },
    {
      id: 'sleep',
      title: 'Sueño',
      icon: 'ri-moon-line',
      color: 'from-indigo-500 to-purple-600',
      onClick: () => navigate('/sleep')
    },
    {
      id: 'diapers',
      title: 'Pañales',
      icon: 'ri-gift-line',
      color: 'from-orange-500 to-amber-600',
      onClick: () => navigate('/diapers')
    },
    {
      id: 'growth',
      title: 'Crecimiento',
      icon: 'ri-bar-chart-line',
      color: 'from-blue-500 to-cyan-600',
      onClick: () => navigate('/growth')
    },
    {
      id: 'vaccination',
      title: 'Vacunas',
      icon: 'ri-syringe-line',
      color: 'from-red-500 to-pink-600',
      onClick: () => navigate('/vaccination')
    },
    {
      id: 'ai-chat',
      title: 'Consultar IA',
      icon: 'ri-robot-2-line',
      color: 'from-violet-500 to-purple-600',
      onClick: () => navigate('/ai-chat')
    }
  ];

  const quickActions = [
    {
      icon: 'ri-restaurant-line',
      label: 'Alimentar',
      color: 'bg-green-100 text-green-600',
      path: '/feeding'
    },
    {
      icon: 'ri-drop-line',
      label: 'Pañal',
      color: 'bg-yellow-100 text-yellow-600',
      path: '/diapers'
    },
    {
      icon: 'ri-hotel-bed-line',
      label: 'Dormir',
      color: 'bg-purple-100 text-purple-600',
      path: '/sleep'
    },
    {
      icon: 'ri-syringe-line',
      label: 'Vacunas',
      color: 'bg-blue-100 text-blue-600',
      path: '/vaccination'
    },
    {
      icon: 'ri-ruler-line',
      label: 'Crecimiento',
      color: 'bg-pink-100 text-pink-600',
      path: '/growth'
    }
  ];

  return (
    <>
      <div className="bg-white rounded-2xl p-6 shadow-sm border border-gray-100">
        <h2 className="text-lg font-semibold text-gray-800 mb-4">Acciones rápidas</h2>
        <div className="grid grid-cols-2 gap-3">
          {actions.map((action) => (
            <button
              key={action.id}
              onClick={action.onClick}
              className={`p-4 rounded-xl bg-gradient-to-r ${action.color} text-white shadow-lg hover:shadow-xl transform hover:scale-105 transition-all duration-200`}
            >
              <i className={`${action.icon} text-xl mb-2 block`}></i>
              <span className="text-sm font-medium">{action.title}</span>
            </button>
          ))}
        </div>
      </div>

      {showAddBabyModal && (
        <AddBabyModal onClose={() => setShowAddBabyModal(false)} />
      )}

      {showAddActivityModal && (
        <AddActivityModal onClose={() => setShowAddActivityModal(false)} />
      )}
    </>
  );
}
